module.exports = __webpack_public_path__ + "static/media/29BDOS21.4a30dfce.jpg";